const defaultOptions = {};
export default function (source, callback, options) {
  const element = document.createElement('link');

  // Merge with default options.
  options = options ? Object.assign({}, defaultOptions, options) : defaultOptions;
  // Assign options.
  if (options.id) {
    element.setAttribute('id', options.id);
  }
  element.href = source;
  element.rel = 'stylesheet';
  if (callback) {
    element.addEventListener('load', callback, {
      once: true
    });
  }
  document.body.appendChild(element);
}